import { render, staticRenderFns } from "./ProductCampaignReview.vue?vue&type=template&id=203329e9&"
import script from "./ProductCampaignReview.vue?vue&type=script&lang=js&"
export * from "./ProductCampaignReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductCampaignReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductCampaignReview.vue"
export default component.exports